export async function postExit(session: number, exitType: 'vbo' | 'external') {
    const apiUrl = window.react_data.api_url || 'http://localhost:8000/api/v1/';
    const data = new FormData();
    data.append('session', session.toString());
    data.append('exit_type', exitType);
    return fetch(apiUrl + 'exit', { body: data, method: 'post' }).catch(() => {});
}
